module.exports = __webpack_public_path__ + "img/debit.00701cf4.png";